import { useTranslation } from "react-i18next";
import LegalPage, { type LegalSection } from "./LegalPage";

export default function CookiePolicy() {
  const { t } = useTranslation();
  const sections = t("legal.cookies.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t("common.legal.cookiePolicy")}
      updated={t("legal.cookies.updated")}
      sections={sections}
    />
  );
}
